import React from 'react';
import { Bell, AlertCircle, Info } from 'lucide-react';
import { mockNotifications } from '../../services/mockData';

const NotificationsCard = () => {
  const notifications = mockNotifications;

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return 'Earlier';
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high':
        return <AlertCircle size={16} className="text-red-500" />;
      case 'medium':
        return <Bell size={16} className="text-yellow-500" />;
      default:
        return <Info size={16} className="text-blue-500" />;
    }
  };

  const getPriorityBg = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-red-50 border-red-200';
      case 'medium':
        return 'bg-yellow-50 border-yellow-200';
      default:
        return 'bg-blue-50 border-blue-200';
    }
  };

  return (
    <div className="card" data-testid="notifications-card">
      <div className="card-header">
        <h2 className="card-title">Notifications</h2>
        <a href="/notifications" className="card-action">See All</a>
      </div>

      {notifications.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">🔔</div>
          <p className="empty-state-text">No notifications</p>
        </div>
      ) : (
        <div className="space-y-2">
          {notifications.map((notif) => (
            <div
              key={notif.notification_id}
              className={`p-3 rounded-lg border ${
                notif.is_unread ? getPriorityBg(notif.priority) : 'bg-gray-50 border-gray-200'
              } cursor-pointer hover:shadow-md transition-all`}
              data-testid={`notification-${notif.notification_id}`}
            >
              <div className="flex items-start gap-3">
                <div className="text-2xl flex-shrink-0">{notif.icon}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between mb-1">
                    <h3 className="text-sm font-semibold text-gray-900">{notif.title}</h3>
                    {notif.is_unread && (
                      <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0 mt-1"></span>
                    )}
                  </div>
                  <p className="text-xs text-gray-600 mb-1">{notif.snippet}</p>
                  <div className="flex items-center gap-2">
                    {getPriorityIcon(notif.priority)}
                    <span className="text-xs text-gray-600">{formatTimestamp(notif.timestamp)}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsCard;
